<template>
  <div>
    <tool-bar :title="title"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item :show="!showRefreshItem"></stage-comment-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <div v-if="showUI" class="margin_top_20">
      <div class="margin-left-10 margin-right-10 box-shadow padding-10">
        <weex-text class="item-bold-lg-heading">Resend Singing Link</weex-text>
        <weex-text class="margin-top-10 font-size-sm-base" v-html="stageInstructions"></weex-text>
      </div>

      <weex-text
        v-if="showSignDocumentLinkMessageOption"
        class="margin-left-10 margin-right-10 margin_top_20">
        <span class="font-size-sm">In case customer did not receive message,</span>
        <span class="item-sm-link" @click="showSignDocumentLinkMessage=true">click here.</span>
      </weex-text>

      <div
        v-if="showSignDocumentLinkMessage"
        class="margin-left-10 margin-right-10 margin_top_20 box-shadow padding-10">
        <weex-text class="item-bold-lg-heading">Message</weex-text>
        <weex-text
          style="overflow-wrap: break-word"
          class="margin-top-10 font-size-sm-base"
          v-html="signDocumentLinkMessage"
        ></weex-text>
      </div>

      <wxc-button
        :text="nextButtonText"
        class="button_horizontal_center margin_top_40 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import ToolBar from "../layout/ToolBar";
import Loading from "../layout/Loading";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import StageCommentItem from "../layout/StageCommentItem";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import { Activities } from "../../utils/ActivityNavigator";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import RefreshItem from "../layout/RefreshItem";
import DataSource from "../../data/DataSource";

export default {
  name: "ResendSigningDocumentLinkActivity",
  components: {
    ActivityRedirectItem,
    ErrorAlertItem,
    Loading,
    ToolBar,
    WxcButton,
    StageCommentItem,
    RefreshItem
  },
  data: () => ({
    title: "Resend Signing Link",
    showUI: false,
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,
    showSignDocumentLinkMessage: false,
    nextButtonText: "Next",
    stageInstructions: "",
    signDocumentLinkMessage: ""
  }),

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onSubmit() {
      LoanScopeDataHolder.setResendSigningDocumentTryCount(
        LoanScopeDataHolder.getResendSigningDocumentTryCount() + 1
      );
      this.completeCurrentTaskAndGetNextTask();
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        })
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), this.currentTaskName)
        .then(stageConfigDataRes => {
          this.loading = false;
          if (stageConfigDataRes.errorOccurred) {
            this.showError(stageConfigDataRes.data);
            this.showRefreshItem = true;
          } else {
            this.showUI = true;
            const stageProperties = stageConfigDataRes.data
              ? stageConfigDataRes.data.properties
              : {};
            if (stageProperties) {
              this.nextButtonText = stageProperties["next.button.instruction"]
                ? stageProperties["next.button.instruction"]
                : "Next";
              this.stageInstructions = stageProperties["stage.instructions"];
              this.signDocumentLinkMessage = stageProperties["sign.document.link.message"];
            }
          }
        })
    }
  },

  created: function () {
    this.fetchInitialData();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.RESEND_SIGNING_DOCUMENT_LINK];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    showSignDocumentLinkMessageOption() {
      return this.signDocumentLinkMessage
        && !this.showSignDocumentLinkMessage
        && LoanScopeDataHolder.getResendSigningDocumentTryCount() > 1;
    }
  }
}
</script>

<style scoped src="../../assets/style/base.css"></style>
